import { render, staticRenderFns } from "./EMLViewer.vue?vue&type=template&id=45671368&scoped=true"
import script from "./EMLViewer.vue?vue&type=script&lang=js"
export * from "./EMLViewer.vue?vue&type=script&lang=js"
import style0 from "./EMLViewer.vue?vue&type=style&index=0&id=45671368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45671368",
  null
  
)

export default component.exports